import { ButtonGroup, Button } from '@blueprintjs/core';
import styles from './Lender.module.css';
import { useApplicationDataStore } from '../../../store/applicationDataStore';
import { useFormContext } from 'react-hook-form';
import { ApplicationDataFormValues } from '../../ApplicationData/ApplicationDataForm/ApplicationDataFormSchema';
import { ConditionalTooltip } from '../../ConditionalTooltip/ConditionalTooltip';
import { useCollateralFormStore } from '../../../forms/collateral/store';

export function LoanRequestActionButtons({
  applicationID,
  isLoading,
}: {
  applicationID: string;
  isLoading: boolean;
}) {
  const { setIsEditing, goToPreviousPage } =
    useApplicationDataStore(applicationID);
  const { reset, formState, watch, resetField } =
    useFormContext<ApplicationDataFormValues>();
  const { isEditing: isEditingCollateral } =
    useCollateralFormStore(applicationID);

  const selectedLenders = watch('SelectedLenders');

  return (
    <ButtonGroup>
      <Button
        variant="minimal"
        icon="delete"
        className={styles.buttonRightBorder}
        onClick={() => {
          reset();
          setIsEditing(false);
        }}
        disabled={formState.isSubmitting}
      >
        Cancel
      </Button>
      <Button
        variant="minimal"
        icon="arrow-left"
        className={styles.buttonRightBorder}
        onClick={() => {
          goToPreviousPage();
          resetField('SelectedLenders');
          resetField('ApplicantMode');
        }}
        disabled={formState.isSubmitting}
      >
        Edit
      </Button>
      <ConditionalTooltip
        conditions={[
          {
            isTooltipVisible: selectedLenders.size === 0,
            tooltipContent: 'Please select at least one lender',
            isChildDisabled: true,
          },
          {
            isTooltipVisible: isEditingCollateral.size > 0,
            tooltipContent:
              'Save your collateral changes before sending to bank',
            isChildDisabled: true,
          },
        ]}
        render={(disabled) => (
          <Button
            variant="minimal"
            disabled={disabled}
            loading={formState.isSubmitting || isLoading}
            icon="send-to-graph"
            type="submit"
          >
            Send
          </Button>
        )}
      />
    </ButtonGroup>
  );
}
